export default "//static.tradera.net/touchweb/static/output/images/network-ig.9323cdfe.svg";